import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { FlowerLarge } from './flower-large'
import { FlowerSmall } from './flower-small'
import { TextContainer } from 'components/container'

export const Flower = () => {
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)

  return (
    <TextContainer>
      {isMobile ? <FlowerSmall /> : <FlowerLarge />}
    </TextContainer>
  )
}
